module.exports = __webpack_public_path__ + "static/img/about2_2.332e308a.jpg";